export default "__VITE_ASSET__BSSXLBva__"